import React, { useContext } from 'react';
import { BackToTop, Box, Media, Optional, useThemeContext } from '@honda-canada/design-system-react';

import BottomElementContext from './service/BottomElementProvider/BottomElementContext';
import DesktopFooter from './Desktop/DesktopFooter';
import FooterContext from './service/FooterContext';
import FooterProvider from './service/FooterProvider';
import MobileFooter from './Mobile/MobileFooter';
import themeStyles from './Footer.styles';
import { Screen } from '../../utils/components/ForPrint.styles';

const FooterWrapper = themeStyles.apply('footer', 'FooterWrapper');
const BackToTopButton = themeStyles.apply(BackToTop, 'BackToTopButton');
const BackToTopWrapper = themeStyles.apply(Box, 'BackToTopWrapper');

const FooterUI = () => {
  const { setRef, isHidden } = useContext(BottomElementContext);
  const { backToTopData, footerFontFamily } = useContext(FooterContext);
  const { colors } = useThemeContext();

  return (
    <FooterWrapper fontFamily={footerFontFamily}>
      <Media lessThan="desktop">
        <MobileFooter />
      </Media>
      <Media greaterThanOrEqual="desktop">
        <DesktopFooter />
      </Media>
      <Optional when={backToTopData}>
        <BackToTopWrapper ref={setRef} isHidden={isHidden}>
          <BackToTopButton backToTopLabel={backToTopData?.backToTopLabel} arrowColor={colors?.red} />
        </BackToTopWrapper>
      </Optional>
    </FooterWrapper>
  );
};
const Footer = props => (
  <FooterProvider {...props}>
    <Screen>
      <FooterUI />
    </Screen>
  </FooterProvider>
);

export default Footer;
